import { IntegrationType } from '../integrationType';
import { IntegrationQueueType, IntegrationEventType } from '../integrationEventQueueEnums';
export const integrationEventQueueSchema = {
    $id: 'urn:wisepipe-domain-authorize:IntegrationEventQueue',
    type: 'object',
    properties: {
        integrationSource: { type: 'string' },
        integrationType: { type: 'string', enum: Object.values(IntegrationType) },
        integrationEventType: { type: 'string', enum: Object.values(IntegrationEventType) },
        sqsQueueUrl: { type: 'string' },
        kinesisStreamArn: { type: 'string' },
        integrationQueueType: { type: 'string', enum: Object.values(IntegrationQueueType) },
        accessorRoleArn: { type: 'string' },
        snsTopicArn: { type: 'string' }
    },
    required: ['integrationSource', 'integrationType'],
    if: { required: ['integrationQueueType'] },
    then: {
        allOf: [
            {
                if: { properties: { integrationQueueType: { const: IntegrationQueueType.Sqs } } },
                then: { required: ['sqsQueueUrl'] }
            },
            {
                if: { properties: { integrationQueueType: { const: IntegrationQueueType.Kinesis } } },
                then: { required: ['kinesisStreamArn'] }
            },
            {
                if: { properties: { integrationQueueType: { const: IntegrationQueueType.Sns } } },
                then: { required: ['snsTopicArn'] }
            }
        ]
    }
};
//# sourceMappingURL=integrationEventQueue.js.map